import { render, staticRenderFns } from "./subdepartment.vue?vue&type=template&id=96418f70&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./subdepartment.vue?vue&type=style&index=0&id=96418f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96418f70",
  null
  
)

export default component.exports